import { useTypedParams } from '@sorare/routing';

import { PlayerWatchlists } from '#src/components/player/Watchlists/index.tsx';

import type { PageParams } from './__generated__/routeParams.ts';

const Watchlists = () => {
  const { slug } = useTypedParams<PageParams>();
  return <PlayerWatchlists slug={slug} />;
};

export default Watchlists;
